import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const carlineInRowSelector = createSelector(
    entryDataSelector,
    (entryData): number | undefined => entryData.carlineInRow,
)

export default carlineInRowSelector
